import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import AppWrapper from '../../app-wrapper';
import Loader from '../../components/loader';
import HeaderWithImage from './ffwd-components/header-with-image/header-with-image';
import SummarySection from './ffwd-components/summary-section/summary-section';
import SubmitSiteSection from './ffwd-components/submit-site-section/submit-site-section';
import RecommendedPlans from './ffwd-components/recommended_plans/recommended_plans';
import ViewHeader from '../../components/view-header';
import AccountDetails from '../ngm-homepage/ngm-components/account_details/account_details';
import {
  stripStartingAndEndingPTags,
  prepareIsdnCallbackData,
  validatePhoneNumber,
  validateNumber,
} from '../ssm-homepage/ssm-homepage.actions';
import ConfirmSiteModal from './ffwd-components/confirm-site-modal/confirm-site-modal';
import FloatingCta from '../../components/floating-cta';
import RequestCallBackModalOffline from '../ssm-homepage/ssm-components/request-callback-modal/request-callback-modal-offline';
import TransitionInformation from './ffwd-components/transition-information/transition-information';
import { updateLiveChatValues, showHideOldNewHeaderFooter } from '../../app-actions';
import { WINDOW_START_POSITION } from '../../app-constants';
import './ffwd-homepage.css';

class FFWDHomePageView extends Component {
  state = {
    termsAndConditions: false,
    reviewTermsAndConditions: false,
    oldPlanNumbersHideShowData: [],
    newPlanNumbersHideShowData: [],
    modalIsOpen: false,
    formSubmittedLoader: false,
    callBackRequestLiveChatOfflineModalIsOpen: false,
    callBackRequestCompleted: false,
    callBackPhoneNumber: '',
    IsCallBackPhoneNumberhasError: false,
    selectedPlanNumber: '',
    selectedPlanType: '',
    currentPlanTableExpandCollapse: false,
    suggestPlanExpandCollapse: false,
    scrollBothSide: false,
  };

  componentDidMount = () => {
    showHideOldNewHeaderFooter(true);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataLoaded !== this.props.dataLoaded && this.props.dataLoaded && this.props.formSubmitted === false) {
      this.setCallbackPhonenumber(this.props.customerContactPhone);
      updateLiveChatValues(this.props.authorableContent.liveChat, 'FFWD');
    }
  }

  onChangedConfirmCheckBox = ({ checked }) => {
    this.setState({ termsAndConditions: checked });
  };

  onChangedSubmitCheckBox = ({ checked }) => {
    this.setState({ reviewTermsAndConditions: checked });
  };

  onSubmitSiteConfirmButton = () => {
    this.setState({ modalIsOpen: true });
  };

  onSubmitSiteSubmitButton = () => {
    this.setState({ formSubmittedLoader: true });
    const { submitFFWDCustomerData } = this.props.actions;
    const submitData = {};
    submitFFWDCustomerData(submitData);
  };

  onCloseDialogBox = () => {
    this.setState({
      termsAndConditions: false,
      reviewTermsAndConditions: false,
      modalIsOpen: false,
    });
  }

  onOpenRequestCallBack = () => {
    this.setState({ callBackRequestLiveChatOfflineModalIsOpen: true });
  }

  onCloseRequestCallBackOffline = () => {
    this.setState({ callBackRequestLiveChatOfflineModalIsOpen: false,
      callBackRequestCompleted: false });
  }

  onRequestCallBackCompleted = () => {
    const { submitFFWDRequestCallback } = this.props.actions;
    const { callBackPhoneNumber } = this.state;
    const { customerContactPhone } = this.props;
    const callBackData = prepareIsdnCallbackData(customerContactPhone !== callBackPhoneNumber ? callBackPhoneNumber : '');
    this.setState({ callBackRequestCompleted: true });
    submitFFWDRequestCallback(callBackData);
  }

  setCallbackPhonenumber = (phoneNumber) => {
    const callBackPhoneNumber = this.state.callBackPhoneNumber || phoneNumber;
    this.setState({ callBackPhoneNumber });
  }

  handleCallbackPhoneNumberOnChange = (event) => {
    let callBackPhoneNumber = this.state.callBackPhoneNumber || '';
    if (event.target.value.length < 11 && validateNumber(event.target.value)) {
      callBackPhoneNumber = event.target.value;
      this.setState({ callBackPhoneNumber });
    }
  }

  handleCallbackPhoneNumberOnBlur = (event) => {
    let IsCallBackPhoneNumberhasError = this.state.IsCallBackPhoneNumberhasError || false;
    IsCallBackPhoneNumberhasError = !validatePhoneNumber(event.target.value) || event.target.value.length !== 10;
    this.setState({ IsCallBackPhoneNumberhasError });
  }

  render() {
    if (this.props.dataLoaded && this.props.formSubmitted === false && this.props.alreadySubmitted === false) {
      const {
        ffwd: {
          title: pageTitle,
          imagePath: imageUrl,
          description,
          whatToExpectHeading: benefitHeading,
        },
        summarySection: {
          headingText: summaryTitle,
          legalContent: summaryText,
          showContractSection,
          confirmButton,
          description: checkboxDescription,
          tAndCText: checkBoxLabel,
        },
        confirmDetails: {
          accountNameText,
          abnText,
        },
        recommededPlans,
        recommededPlans: {
          estimatedTotalMonthlyCharges: {
            title,
            tooltip: toolTip,
            monthText: perLabel,
            inclGSTText,
          },
          newEstimatedTotalMonthlyCharges: {
            title: newTitle,
            tooltip: newToolTip,
            monthText: newPerLabel,
            inclGSTText: newPlanInclGSTText,
          },
          gbText,
          totalSpendPerMonth: totalMonthText,
          totalDataInclusion: totalInclusionText,
        },
        submissionModal,
        requestCallBack: {
          requestCallBackModal: {
            title: requestCallbackOfflineTitle,
            text: requestCallbackOfflineText,
            yesText: requestCallbackOfflineYesText,
            formFields: requestCallbackOfflineFormfields,
          },
          thankYouModal: {
            title: callbackThankYouTitle,
            text: callbackThankYouText,
          },
          floatingCtaCallBack: {
            icon: callbackIcon,
            text: callbackText,
          },
        },
        benefit1,
        benefit2,
        benefit3,
        moreDataBenefit,
        amountPerMonthBenefit,
        additionalDataBenefit,
      } = this.props.authorableContent;

      const {
        customerAccountName,
        customerAbn,
        planDetails,
        suggestedPlanDetails,
        totalCurrentDataInclusionPerMonth,
        totalFutureDataInclusionPerMonth,
        totalCurrentSpentPerMonth,
        totalFutureSpentPerMonth,
        benefitValues,
      } = this.props;

      const estimatedTotalCurrentMonthlyCost = {
        title,
        toolTip,
        perLabel,
        totalCost: Math.floor(parseFloat(totalCurrentSpentPerMonth)),
        dataInclusion: totalCurrentDataInclusionPerMonth,
        inclGSTText,
        gbText,
        totalMonthText,
        totalInclusionText,
      };

      const estimatedTotalNewMonthlyCost = {
        title: newTitle,
        toolTip: newToolTip,
        perLabel: newPerLabel,
        totalCost: Math.floor(parseFloat(totalFutureSpentPerMonth)),
        dataInclusion: totalFutureDataInclusionPerMonth,
        inclGSTText: newPlanInclGSTText,
        gbText,
        totalMonthText,
        totalInclusionText,
        asterisk: '*',
      };

      const callbackCta = [
        {
          icon: callbackIcon,
          text: callbackText,
          onCtaClick: () => {
            this.onOpenRequestCallBack();
          },
        },
      ];

      const requestCallBackOfflineAuthorableContent = {
        requestCallbackOfflineTitle,
        requestCallbackOfflineText,
        requestCallbackOfflineYesText,
        requestCallbackOfflineFormfields,
        callbackThankYouTitle,
        callbackThankYouText,
      };

      return (
        <AppWrapper>
          <div className="ffwd-homepage root-container container">
            <AccountDetails
              accountNameText={accountNameText}
              abnText={abnText}
              customerAccountName={customerAccountName}
              customerAbn={customerAbn}
            />

            <HeaderWithImage
              title={pageTitle}
              text={description}
              image={imageUrl}
            />

            <RecommendedPlans
              recommededPlans={recommededPlans}
              recommededPlanDescription={recommededPlans.recommededPlanDescription}
              planDetails={planDetails}
              suggestedPlanDetails={suggestedPlanDetails}
              estimatedTotalCurrentMonthlyCost={estimatedTotalCurrentMonthlyCost}
              estimatedTotalNewMonthlyCost={estimatedTotalNewMonthlyCost}
              benefitValues={benefitValues}
              moreDataBenefit={moreDataBenefit}
              amountPerMonthBenefit={amountPerMonthBenefit}
              additionalDataBenefit={additionalDataBenefit}
            />
            <TransitionInformation
              title={benefitHeading}
              benefit1={benefit1}
              benefit2={benefit2}
              benefit3={benefit3}
            />
            {showContractSection === 'true' && (
              <SummarySection
                title={summaryTitle}
                summaryText={summaryText}
              />
            )}
            <SubmitSiteSection
              confirmButton={confirmButton}
              description={renderHTML(stripStartingAndEndingPTags(checkboxDescription))}
              checkBoxLabel={checkBoxLabel}
              ischeckConfirmBoxChecked={this.state.termsAndConditions}
              onChangedConfirmCheckBox={this.onChangedConfirmCheckBox}
              onSubmitSiteConfirmButton={this.onSubmitSiteConfirmButton}
            />
            <ConfirmSiteModal
              authorableContent={submissionModal}
              submitLoader={this.state.formSubmittedLoader}
              reviewTermsAndConditions={this.state.reviewTermsAndConditions}
              modalIsOpen={this.state.modalIsOpen}
              onCloseDialogBox={this.onCloseDialogBox}
              onChangedSubmitCheckBox={this.onChangedSubmitCheckBox}
              handleSubmit={this.onSubmitSiteSubmitButton}
            />
            <FloatingCta ctas={callbackCta} />
            <RequestCallBackModalOffline
              customerContactPhone={this.state.callBackPhoneNumber}
              modalIsOpen={this.state.callBackRequestLiveChatOfflineModalIsOpen}
              onCloseDialogBox={this.onCloseRequestCallBackOffline}
              onRequestCallback={this.onRequestCallBackCompleted}
              authorableContent={requestCallBackOfflineAuthorableContent}
              callBackRequestCompleted={this.state.callBackRequestCompleted}
              IsCallBackPhoneNumberhasError={this.state.IsCallBackPhoneNumberhasError}
              onBlur={this.handleCallbackPhoneNumberOnBlur}
              onChange={this.handleCallbackPhoneNumberOnChange}
            />
          </div>
        </AppWrapper>
      );
    } else if (this.props.dataLoaded && this.props.formSubmitted) {
      const {
        confirmation:
          {
            heading,
            description,
            tcDescription,
          },
      } = this.props.authorableContent;
      const telstraConnectOnboarded = this.props.telstraConnectOnboarded;
      const headingWithReferenceNumber = `${heading} ${this.props.referenceNumber}`;
      const confirmationHeader = {
        heading: headingWithReferenceNumber,
        description: renderHTML(stripStartingAndEndingPTags(description)),
      };
      window.scrollTo(WINDOW_START_POSITION, WINDOW_START_POSITION);
      return (
        <AppWrapper>
          <div className="ffwd-homepage root-container container confirm-page">
            <ViewHeader content={confirmationHeader} />
            {telstraConnectOnboarded && (
              <div className="row">
                <div className="col-12 pl-sm-0">
                  {renderHTML(stripStartingAndEndingPTags(tcDescription))}
                </div>
              </div>
            )
            }
          </div>
        </AppWrapper>
      );
    } else if (this.props.dataLoaded && this.props.alreadySubmitted) {
      const {
        summarySection:
          {
            alreadySubmittedHeading,
            alreadySubmittedDescription,
          },
      } = this.props.authorableContent;
      const alreadySubmissionHeader = {
        heading: alreadySubmittedHeading,
        description: renderHTML(stripStartingAndEndingPTags(alreadySubmittedDescription)),
      };
      return (
        <AppWrapper>
          <div className="ffwd-homepage root-container container already-submitted-page">
            <ViewHeader content={alreadySubmissionHeader} />
          </div>
        </AppWrapper>
      );
    }

    return <Loader />;
  }
}
export default FFWDHomePageView;
